import React from 'react';

import ComboBox, {ComboboxItem} from '@pb/kit-component-combo-box';
import Label from '@pb/kit-component-label';

type Props = {
    value?: boolean,
    onChange: (value?: boolean) => void,
    label: string,
};

export const YesNoFilter = ({value, onChange, label}: Props) => {
    return (
        <div style={{width: 300}}>
            <Label>{label}</Label>
            <ComboBox value={value} onChange={onChange} placeholder={label}>
                <ComboboxItem caption="Yes" value={true}/>
                <ComboboxItem caption="No" value={false}/>
            </ComboBox>
        </div>
    );
};
